var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"_dropzone"},[_c('vue2Dropzone',{ref:"vueDropzone",attrs:{"id":"_dropzone__dropzone","options":_vm.dropzoneOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }